var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":_vm.title,"color":_vm.pageframe_color}},[_c('v-container',[(_vm.contact_request != null)?_c('m-contact-request-card',{attrs:{"contact_request":_vm.contact_request},on:{"search":function($event){return _vm.updateContactRequest();}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }